import * as actions from './DisregardedListActions'

export default (state = { ...actions.DISREGARDED_LIST_INITIAL_STATE }, action = {}) => {
  switch (action.type) {
    case actions.DISREGARDED_LIST_FETCH: {
      return state
    }
    case actions.DISREGARDED_LIST_FETCH_CANCELED: {
      return { ...actions.DISREGARDED_LIST_INITIAL_STATE }
    }
    case actions.DISREGARDED_LIST_FETCH_ERROR: {
      return { ...state, ...action.payload }
    }
    case actions.DISREGARDED_LIST_FETCH_FULFILLED: {
      return { ...state, ...action.payload }
    }
    default:
  }
  return state
}
